import filterProcuredOffers from '../filterProcuredOffers';

const filterDestinationsFromCampaignProperties = (
  destinations,
  campaignProperties,
) =>
  destinations.filter(({ name }) =>
    filterProcuredOffers(campaignProperties).some(
      ({ propertyContent: { destination } }) => destination.name === name,
    ),
  );

export default filterDestinationsFromCampaignProperties;
